import React from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './InputSuccessMessage.scss';
/**
 * A success message! Meant to follow an input field.
 */ const InputSuccessMessage = ({ children, className })=>{
    const largerText = useFlag('input_label_font');
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], largerText && s['larger'], className)
    }, children);
};
InputSuccessMessage.displayName = 'InputSuccessMessage';
export default InputSuccessMessage;
